<template>
  <el-card
    id="myMiniSurvey"
    v-loading="loading"
    shadow="hover"
    class="clear-card myMiniSurvey"
    :class="$mq"
  >
    <div
      slot="header"
      class="clearfix title defaultCursor"
    >
      <span>{{ $t('aside.pulse') }}</span>
    </div>

    <div
      class="content"
      :class="session >= 7 ? 'filledData' : ''"
    >
      <template v-if="pulse">
        <div class="charts">
          <PulseScoreLeader
            key="realPulse"
            :report="formattedPulseData"
          />
        </div>
      </template>

      <template v-else>
        <div class="no-data defaultCursor">
          {{ $t('common.noData') }}
        </div>
      </template>
    </div>

    <div
      v-if="pulse"
      class="footer"
    >
      <el-button
        class="footerBtn"
        round
        :disabled="!pulse"
        @click="goToPulse"
      >
        {{ $t('settings.viewDetails') }}
      </el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  components: {
    PulseScoreLeader: () => import(/* webpackChunkName: "Charts" */
      '@/views/dashboard/content/common/welcome/widgets/charts/PulseScoreLeader.vue'
    ),
  },

  props: {
    engagementUuid: {
      type: String,
      default: '1',
    },

    pulse: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      responses: {
        pulse1: null,
        pulse2: null,
        pulse3: null,
      },
      loading: false,
      session: 10, // TMP
    };
  },

  computed: {
    formattedPulseData() {
      const pulse = JSON.parse(JSON.stringify(this.pulse));
      if (pulse.pulse1) delete pulse.pulse1.respondent_ct;
      if (pulse.pulse2) delete pulse.pulse2.respondent_ct;
      if (pulse.pulse3) delete pulse.pulse3.respondent_ct;
      return pulse;
    },
  },

  methods: {
    goToPulse() {
      this.$router.push({
        name: 'leaderEngagementPulse',
        params: {
          id: this.engagementUuid,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#myMiniSurvey {
  height: 100%;

  .title {
    text-align: center;
  }

  &:not(.mobile):not(.tablet) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 40px);
    min-height: 120px;
    font-style: italic;
    text-align: center;
    color: #c4c4c4;

    .charts {
      width: 100%;
    }

    .nbRespondent {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: var(--themeFontColor);
      text-align: left;
      margin-left: 25px;

      .subject {
        padding-right: 10px;
      }

      .pulseDivide {
        padding-right: 10px;
      }

      .textBold {
        font-weight: bold;
      }
    }

    .no-data {
      display: flex;
      font-style: italic;
      color: #c4c4c4;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      padding: 50px 0 60px;
    }
  }

  .footer {
    text-align: center;
    .footerBtn {
      background-color: transparent;
      color: var(--themeFontColor);
    }
  }
}
</style>

<style lang="scss">
#myMiniSurvey {
  .el-card__header {
    font-weight: bold;
  }

  .el-card__body {
    height: calc(100% - 56px);
    box-sizing: border-box;
  }

  &.mobile,
  &.tablet {
    .el-card__header {
      border-bottom: 0;
    }
  }

  .hello {
    &::before {
      top: calc(5% - 2px);
      height: calc(100% - 87px);
    }
  }
}
</style>
